/* global axios */
import ApiClient from './ApiClient';

class ConversationReportsAPI extends ApiClient {
  constructor() {
    super('conversation_reports', { accountScoped: true });
  }

  get({ page, from, to, agents, channels, teams, startReason, endReason }) {
    return axios.get(this.url, {
      params: {
        page,
        since: from,
        until: to,
        agents: agents,
        channels: channels,
        teams,
        start_reason: startReason,
        end_reason: endReason,
        sort: '-created_at',
      },
    });
  }

  getMetrics({ from, to, agents, channels, teams, startReason, endReason }) {
    return axios.get(`${this.url}/metrics`, {
      params: {
        since: from,
        until: to,
        agents: agents,
        channels,
        teams,
        start_reason: startReason,
        end_reason: endReason,
      },
    });
  }

  downloadConversationsReports(conditions) {
    return axios.get(`${this.url}/conversations_export`, {
      params: conditions,
    });
  }
}

export default new ConversationReportsAPI();
